import {
  campaignColumns,
  endedBlockColumns,
  liveBlockColumns,
  pendingBlockColumns,
  planningBlockColumns,
  unassingedBlockColumns,
} from './columns';
import { StageConfig, StageIndicators } from './types';

type StagesConfig = Record<keyof StageIndicators, StageConfig> & {
  pre_campaign: StageConfig;
};

// IMPORTANT: this has to be kept in sync with the backend (dashboard indicators)
export const stages: StagesConfig = {
  pre_campaign: {
    label: 'Pre-campaign',
    blockState: 'NEW',
    children: ['empty_campaigns', 'unassigned_blocks'],
  },
  empty_campaigns: {
    label: 'Empty campaigns',
    blockState: 'NEW',
    url: 'campaign/campaigns/',
    columns: campaignColumns,
    queryParms: { sums__state: 'NEW', empty: true, ordering: 'date_from' },
  },
  unassigned_blocks: {
    label: 'Unassigned blocks',
    blockState: 'NEW',
    url: 'campaign/blocks/',
    columns: unassingedBlockColumns,
    queryParms: { state: 'NEW', ordering: 'date_from' },
  },
  assigned_blocks: {
    label: 'Planning',
    blockState: 'PLANNING',
    url: 'campaign/blocks/',
    columns: planningBlockColumns,
    queryParms: { state: 'PLANNING', ordering: 'deadline' },
  },
  submitted_blocks: {
    label: 'Submitted',
    blockState: 'SUBMITTED',
    url: 'campaign/blocks/',
    columns: planningBlockColumns,
    queryParms: { state: 'SUBMITTED', ordering: 'deadline' },
  },
  pending_blocks: {
    label: 'Pending',
    blockState: 'APPROVED',
    url: 'campaign/blocks/',
    columns: pendingBlockColumns,
    queryParms: { state: 'APPROVED', flight_state: 'PENDING', ordering: 'date_from' },
  },
  live_blocks: {
    label: 'Live',
    blockState: 'APPROVED',
    url: 'campaign/blocks/',
    columns: liveBlockColumns,
    queryParms: { state: 'APPROVED', flight_state: 'LIVE', ordering: 'date_to' },
  },
  ended_blocks: {
    label: 'Ended',
    blockState: 'APPROVED',
    url: 'campaign/blocks/',
    columns: endedBlockColumns,
    queryParms: { state: 'APPROVED', flight_state: 'ENDED', ordering: '-date_to' },
  },
};
